import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  // The twentieth, and the first that was not on digitopia.co's own Hall of
  // Fame page — it comes off the foot of the Intel AI story page, captured on
  // 2026-08-28 ("en aşağıda önceden konuştuğumuz gibi testimonial template ini
  // kullanalım"), which is the same card in the same grey panel. Appended
  // rather than placed: the order above is the live page's own, and a
  // twenty-first sorted into the middle of it would be this file guessing at
  // a marketing decision it has no part in.
  //
  // The mark is the 300×300 transparent card square already in `logo-src/`,
  // not the 400×225 marketing crop sent with the capture: that one is a white
  // rectangle with no alpha, and this card draws marks straight onto grey.
  company: 'Intel AI',
  logo: { name: 'Intel AI', src: '/logo/intelaicard.png' },
  portrait: {
    src: '/photo/portrait-victoria-kouyoumjian.webp',
    alt: 'Victoria Kouyoumjian',
  },
  quote: [
    'Intel’s AI Readiness Assessment, built on Digitopia’s intuitive, self-service platform, '
    + 'empowers customers and prospects to independently evaluate their AI maturity. The '
    + 'resulting clear, actionable report helps identify and bridge organizational gaps, '
    + 'while also fostering trust in Intel as a strategic AI advisor. The assessment starts '
    + 'the conversation, equips customers with actionable insights, and creates valuable '
    + 'opportunities for ongoing engagement.',
  ],
  attribution: 'Victoria Kouyoumjian, Marketing Director, Intel AI',
  story: 'intel-ai',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 19
